import { createStyles, makeStyles } from '@hawkins/styles';
export var menuGroupLabelStyles = function (theme) {
    var hawkins = theme.hawkins, hawkinsVariables = theme.hawkinsVariables;
    return createStyles({
        /** Class name to apply to the label of the menu group label */
        label: {
            padding: "".concat(hawkinsVariables.spacings.space2, " ").concat(hawkinsVariables.spacings.space2, " ").concat(hawkinsVariables.spacings.space2, " ").concat(hawkinsVariables.spacings.space1),
            color: hawkins.textColor.textColorLight,
            display: 'inline-flex',
            lineHeight: 1,
            fontSize: hawkinsVariables.fontSizes.fontSize0,
        },
        /** Class name to apply to the icon of the menu group label */
        icon: {
            color: hawkins.textColor.textColorLight,
            marginRight: hawkinsVariables.spacings.space0,
        },
    });
};
export var useMenuGroupLabelStyles = makeStyles(menuGroupLabelStyles, {
    name: 'Hawkins-MenuGroupLabel',
});
